import {combineReducers} from 'redux';
import types from './types';

// 改造工事費用算定件名一覧
const list = (state = null, action) =>{
  switch (action.type) {
    case types.DR_SIDE_KOJI_COSTLIST:
      return action.list;

    default:
      return state;
  }
};

// 改造工事費用算定件名ID
const id = (state = null, action) =>{
  switch (action.type) {
    case types.DR_SIDE_KOJI_COSTID:
      return action.id;

    default:
      return state;
  }
};

// 改造工事費用算定詳細
const detail = (state = null, action) =>{
  switch (action.type) {
    case types.DR_SIDE_KOJI_COSTDETAIL:
      return action.detail;

    default:
      return state;
  }
};

const reducer = combineReducers({
  list,
  id,
  detail,
});

export default reducer;
